import React, { Component } from 'react';
import styles from './index.less';
import * as ShapeItems from '../../../editor/src/js/constants/shape-default-data';
import IconItem from './shape-item-icon';
import classNames from 'classnames';

export const TopMenuShapeConstant = {
    MAX_HEIGHT: 689,
};

interface TopMenuShapeElementProps {
    hideMenu?: () => void;
    isFromDropdown?: boolean;
    cropPicker?: boolean;
    noBackDrop?: boolean;
    hideToolBar?: boolean;
    isFromInsertPanel?: boolean;
    isFromSingleBar?: boolean;
    wbPath?: string[];
}

interface Config {
    vh: number;
    height: number;
}
interface TopMenuShapeElementState {
    config: Config;
}

/**
 * shape菜单
 */
export default class TopMenuShapeElement extends Component<TopMenuShapeElementProps, TopMenuShapeElementState> {
    private subitems: any;
    private menuDom: any;
    public constructor(props: TopMenuShapeElementProps, context: any) {
        super(props, context);
        this.subitems = [...ShapeItems.ShapeMenuItems];

        if (props.cropPicker) {    // 去掉线条和动作按钮，  调整位置时要注意
            this.subitems.splice(0, 1);
            this.subitems.splice(this.subitems.length - 1, 1);
        }

        this.state = {
            config: {
                vh: 0,
                height: 0,
            },
        };
    }

    public shouldComponentUpdate(): boolean {
        const vh = document.body.clientHeight;
        if ((this.isMenu() && this.menuDom.scrollTop != 0)) {
            this.menuDom.scrollTop = 0;
        }
        // console.log('~_~ shouldComponentUpdate', vh !== this.state.config.vh || this.state.config.height === 0);
        return vh != this.state.config.vh || this.state.config.height == 0;
    }

    public componentDidUpdate() {
        // console.log('~_~ componentDidUpdate');
        this.ajustMenuLoc();
    }

    public componentDidMount() {
        // console.log('~_~ componentDidMount');
        this.ajustMenuLoc();
    }

    public render() {
        let shapemw: React.CSSProperties = {
            width: 318,
            overflowY: 'scroll',
            marginTop: -8,
            // fix safari bug: 某些情况下 dropdown 底部 padding 那一栏会有镂空
            marginBottom: -8,
            paddingBottom: 4,
        };

        if (!this.props.isFromDropdown) {
            shapemw.maxHeight = this.state.config.height;
        }

        if (this.props.cropPicker) {
            shapemw = {
                width: 318,
                // overflowY: 'scroll',
                paddingBottom: 4,
            };
        }

        const wrapperClassName = classNames({
            'menu-scroll': !this.props.cropPicker,
            [styles['shape-pick-menu-container']]: !this.props.noBackDrop,
        });

        // console.log('~_~ render', this.state.config.height);
        return (
            <div ref={(ref) => {
                this.menuDom = ref;
            }} className={wrapperClassName} style={shapemw} key={'shape-menu-wrapper'}>
                {this.subitems.map(subitem => <div key={`thumb-${subitem.grouptype}`}>
                    <div id={`thumb-${subitem.grouptype}`}  key={`wrapper-${subitem.grouptype}`} className={styles.thumbt} >{subitem.grouptype}</div>
                    <div key={`title-${subitem.grouptype}`} className = {styles.thumbiw}>
                        {
                            subitem.groupvalue.map(item => <IconItem
                                key = {`item-${item.type}`}
                                {...item}
                                groupType = {subitem.grouptype}
                                groupid = {subitem.groupid}
                                hideMenu = {this.props.hideMenu}
                                hideToolBar = {this.props.hideToolBar}
                                cropPicker = {this.props.cropPicker}
                                isFromInsertPanel={this.props.isFromInsertPanel}
                                isFromSingleBar={this.props.isFromSingleBar}
                                wbPath={this.props.wbPath}
                            />)
                        }
                    </div>
                </div>)
                }
            </div>
        );
    }
    private isMenu = (): boolean => (!!this.props.hideMenu);

    // 位置自动调整
    private ajustMenuLoc = (): void => {
        // 如果是dropdown的子元素，dropdown来调整高度
        if (this.props.isFromDropdown) {
            return;
        }
        const maxHeight = TopMenuShapeConstant.MAX_HEIGHT;
        const itemDom = this.menuDom;
        const newConfig: any = {};
        if (itemDom) {
            const rect = itemDom.getBoundingClientRect();
            if (this.props.cropPicker) {
                const { top } = rect;
                const vh = document.body.clientHeight;
                const cropMaxHeight = 500;
                newConfig.vh = vh;
                if (top + cropMaxHeight >= vh) {
                    newConfig.height = vh - top - 16;
                } else {
                    newConfig.height = cropMaxHeight;
                }
                this.setState({
                    config: newConfig,
                });

                // console.log('~_~', newConfig, itemDom, rect, vh);
            } else {
                const top = this.isMenu() ? 170 : rect.top;
                const vh = document.body.clientHeight;
                newConfig.vh = vh;
                if (top + maxHeight >= vh) {
                    newConfig.height = this.isMenu() ? vh - top - 16 : vh - top - 55;
                } else {
                    newConfig.height = maxHeight;
                }
                this.setState({
                    config: newConfig,
                });
            }
        } else {
            const top = 170;
            const vh = document.body.clientHeight;
            newConfig.vh = vh;
            if (top + maxHeight >= vh) {
                newConfig.height = this.isMenu() ? vh - top - 16 : vh - top - 55;
            } else {
                newConfig.height = maxHeight;
            }
            this.setState({
                config: newConfig,
            });
        }
    };
}
